import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CFPCcards from "../common/CFPCcards";
import ByDefaultSelected from "../../components-react/ByDefaultSelected";
import DaysTab from "../common/DaysTab";
import { Form } from "react-bootstrap";
import { fetchMealTimesData } from "../../../redux/reducers/dropdownApiSlice";
import { selectToken } from "../../auth/auth.selector";

const ViewGoalDiets = ({ rowData }) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const { mealTimes } = useSelector((state) => state.dropdown);

  const {
    goal_diet,
    name,
    is_paid,
    user_name,
    diet_cat_type,
    type2_name,
    type1_name,
    duration,
    description,
    min_cal,
    max_cal,
    status,
  } = rowData || {};

  const [durationOptions, setDurationOptions] = useState([]);
  const [selectedDays, setSelectedDays] = useState("");
  const [goalDiets, setGoalDiets] = useState([]);
  const [mealCategories, setMealCategories] = useState([]);

  const selectedDaysArray = selectedDays?.label?.split("-")?.map(Number);
  const startDay = selectedDaysArray ? selectedDaysArray[0] : "";
  const endDay = selectedDaysArray ? selectedDaysArray[1] : "";
  const subsetGoalDiets = goalDiets?.slice(startDay - 1, endDay);
  const flattenedSubsetGoalDiets = subsetGoalDiets;
  const iniCalories = {
    calories: { total: 0 },
    fats: { total: 0 },
    proteins: { total: 0 },
    carbs: { total: 0 },
  };
  const [dietCalories, serDietCalories] = useState(iniCalories);

  let totalCalSum = 0;
  let protiensSum = 0;
  let fatsSum = 0;
  let carbsSum = 0;

  const generateDurationOptions = (duration) => {
    const options = [];
    let start = 1;
    while (start <= duration) {
      const end = Math.min(start + 6, duration);
      const label = `${start}-${end}`;
      const value = end - start + 1;
      options.push({ value, label });
      start += 7;
    }
    return options;
  };

  const getInitialFormValues = (dayNumber) => {
    if (goal_diet?.length > 0) {
      const dayGoals = goal_diet?.filter(
        (item) => item.day_no && parseInt(item.day_no) === dayNumber
      );

      return mealCategories.map((mealCategory) => {
        const matchingGoalDiet = dayGoals.find(
          (goal) => goal.diet_time === mealCategory.value
        );

        if (matchingGoalDiet) {
          const mealsArr = matchingGoalDiet.meal_data.map((mealData) => ({
            selectedMeal: {
              label: mealData.name,
              value: mealData.uid,
              info: {
                unit_name: mealData.unit_name,
                unit_id: mealData.unit_id,
              },
            },
            quantity: mealData.quantity || "",
            selectedUnit: "",
            totalCalory: {
              carbs: mealData.carbs_grams,
              fats: mealData.fat_grams,
              protiens: mealData.protien_grams,
              totalCal: mealData.cal,
            },
          }));

          return {
            mealTagline: matchingGoalDiet.diet_time_name,
            mealTaglineValue: matchingGoalDiet.diet_time,
            dayNo: dayNumber,
            totalCalory: matchingGoalDiet.total_cal,
            meals: mealsArr,
          };
        } else {
          return {
            mealTagline: mealCategory.label,
            mealTaglineValue: mealCategory.value,
            dayNo: dayNumber,
            totalCalory: "",
            meals: [
              {
                selectedMeal: "",
                quantity: "",
                selectedUnit: "",
                totalCalory: {},
              },
            ],
          };
        }
      });
    } else {
    }
  };

  if (Array.isArray(goalDiets) && goalDiets.length > 0) {
    goalDiets &&
      goalDiets?.forEach((day) => {
        day?.forEach((meal) => {
          meal.meals.forEach((innerMeal) => {
            const { totalCalory } = innerMeal || {};
            const { totalCal, protiens, fats, carbs } = totalCalory || {};

            const totalCalNum = totalCal ? parseFloat(totalCal) : 0;
            const protiensNum = protiens ? parseFloat(protiens) : 0;
            const fatsNum = fats ? parseFloat(fats) : 0;
            const carbsNum = carbs ? parseFloat(carbs) : 0;

            if (!isNaN(totalCalNum)) {
              totalCalSum += totalCalNum;
            }

            if (!isNaN(protiensNum)) {
              protiensSum += protiensNum;
            }

            if (!isNaN(fatsNum)) {
              fatsSum += fatsNum;
            }

            if (!isNaN(carbsNum)) {
              carbsSum += carbsNum;
            }
          });
        });
      });
  }

  useEffect(() => {
    dispatch(
      fetchMealTimesData({
        token: token,
        qps: "",
        pageNo: 1,
        limit: 1000,
      })
    );
  }, []);

  useEffect(() => {
    if (mealTimes) {
      setMealCategories(mealTimes);
    } else {
      setMealCategories([]);
    }
  }, [mealTimes]);

  useEffect(() => {
    if (duration) {
      const durations = parseInt(duration, 10);
      const options = generateDurationOptions(durations);
      setDurationOptions(options);
    }
  }, [duration]);

  useEffect(() => {
    if (duration && mealCategories?.length > 0) {
      const initialGoalDiets = [];
      const startDay = 1;
      const endDay = duration;
      for (let i = startDay; i <= endDay; i++) {
        initialGoalDiets.push(getInitialFormValues(i));
      }
      setGoalDiets(initialGoalDiets);
    }
  }, [duration, mealCategories]);

  useEffect(() => {
    serDietCalories((prevDPForm) => ({
      ...prevDPForm,
      calories: { total: totalCalSum ? totalCalSum.toFixed(2) : 0 },
      proteins: { total: protiensSum ? protiensSum.toFixed(2) : 0 },
      fats: { total: fatsSum ? fatsSum.toFixed(2) : 0 },
      carbs: { total: carbsSum ? carbsSum.toFixed(2) : 0 },
    }));
  }, [totalCalSum, protiensSum, fatsSum, carbsSum]);

  return (
    <div className="createNewCTOModalContainer view-details-modal mealsModalContainer dietModalContainer mt30">
      <form className="formContainer">
        <div className="formInputsGrid fourGridSystem">
          <div className="formInputBox">
            <label htmlFor="dpName" className="formInputLabel">
              Diet Package Name *
            </label>

            <input
              type="email"
              className="formInput"
              name="email"
              placeholder={`${name || "🚫 NA"}`}
              disabled
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedDietCategory" className="formInputLabel">
              Diet Category *
            </label>

            <input
              type="email"
              className="formInput"
              name="email"
              placeholder={`${diet_cat_type || "🚫 NA"}`}
              disabled
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedPlanType" className="formInputLabel">
              Plan type *
            </label>

            <input
              type="email"
              className="formInput"
              name="email"
              placeholder={`${is_paid === 1 ? "Paid" : "Free" || "🚫 NA"}`}
              disabled
            />
          </div>

          {is_paid === 1 && (
            <div className="formInputBox">
              <label htmlFor="selectedUser" className="formInputLabel">
                Plan user *
              </label>

              <input
                type="email"
                className="formInput"
                name="email"
                placeholder={`${user_name || "🚫 NA"}`}
                disabled
              />
            </div>
          )}

          <div className="formInputBox">
            <label htmlFor="selectedDietPreference" className="formInputLabel">
              Diet Preferences *
            </label>

            <input
              type="email"
              className="formInput"
              name="email"
              placeholder={`${type2_name || "🚫 NA"}`}
              disabled
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedBodyType" className="formInputLabel">
              Diet Type *
            </label>

            <input
              type="email"
              className="formInput"
              name="email"
              placeholder={`${type1_name || "🚫 NA"}`}
              disabled
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="minCal" className="formInputLabel">
              Min Calories *
            </label>

            <input
              type="email"
              className="formInput"
              name="email"
              placeholder={`${min_cal || "🚫 NA"}`}
              disabled
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="maxCal" className="formInputLabel">
              Max Calories *
            </label>

            <input
              type="email"
              className="formInput"
              name="email"
              placeholder={`${max_cal || "🚫 NA"}`}
              disabled
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="planDuration" className="formInputLabel">
              Duration *
            </label>

            <input
              type="email"
              className="formInput"
              name="email"
              placeholder={`${duration || "🚫 NA"}`}
              disabled
            />
          </div>

          <div className="formInputBox gridSpanFour">
            <label htmlFor="planDesc" className="formInputLabel">
              Plan description *
            </label>

            <textarea
              name="planDesc"
              className={`formInput`}
              placeholder={`${description || "🚫 NA"}`}
              disabled
            ></textarea>
          </div>

          <div className="formInputBox  gridSpanFour">
            <CFPCcards
              calories={dietCalories.calories}
              fats={dietCalories.fats}
              proteins={dietCalories.proteins}
              carbs={dietCalories.carbs}
            />
          </div>

          <div className="formInputBox gridSpanFour">
            <label htmlFor="selectedDays" className="formInputLabel">
              Select Days *
            </label>

            <div className={`commonWrapper`}>
              <ByDefaultSelected
                options={durationOptions}
                selectedOption={selectedDays}
                setSelectedOption={(selectedValue) =>
                  setSelectedDays(selectedValue)
                }
                name="Days"
              />
            </div>
          </div>
        </div>

        {selectedDays && (
          <DaysTab
            selectedDays={selectedDays}
            formValues={flattenedSubsetGoalDiets}
            isView={true}
          />
        )}

        <div className="formInputsGrid switchInputs">
          <div className="formInputBox formInputSwitchBox">
            <div className={`commonWrapper commonSwitchWrapper no-border`}>
              <Form.Check
                type="switch"
                name="isActive"
                checked={`${status === "active" ? true : false}`}
                label={`${status === "active" ? "Active" : "Inactive"}`}
                disabled
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ViewGoalDiets;
